<!-- defulat size page -->
<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  [bodyClass]="input_isSmallSizePage ? 'tw-pr-2 tw-pl-5  tw-pt-3' : ''"
  (onAdd)="onCreate('', true)"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-px-4 tw-text-base tw-text-right tw-py-0">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- title -->
        <td class="tw-py-0 tw-text-center">
          <td-value
            class="tw-text-base"
            copyToClipboard
            [value]="item?.title"
          ></td-value>
        </td>

        <!-- smsTemplateGroupTitle -->
        <td
          class="tw-py-0 tw-text-center tw-text-base"
          *ngIf="!input_isSmallSizePage"
        >
          <td-value
            class="tw-text-base"
            copyToClipboard
            [value]="item?.smsTemplateGroupTitle"
          ></td-value>
        </td>

        <!-- body -->
        <td class="large-text tw-py-0 tw-text-center tw-cursor-pointer">
          <app-expand-text [placement]="'right'">
            <span small-text class="text-gray tw-text-base" copyToClipboard>
              {{ item?.body }}</span
            >
            <div full-text class="full-text-display tw-w-[250px]">
              {{ item?.body }}
            </div>
          </app-expand-text>
        </td>
        <!------------------------------- operations -------------------------------->
        <td class="sticky-td">
          <app-table-operations
            [model]="item"
            (onDelete)="onDelete(item)"
            (onUpdate)="baseGetByIdApi(item.id)"
          >
          </app-table-operations>

          <a
            *ngIf="input_isModalMode"
            (click)="onSelect(item.body)"
            class="text-info tw-font-bold tw-cursor-pointer"
            [matTooltip]="'common.select' | translate"
          >
            <i class="mdi mdi-text-box-plus-outline text-blue mdi-24px"></i>
          </a>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-------------------------------------------- Audit ---------------------------------------------->

<ng-container *ngIf="pageConfig?.isVisibleAuditPage && !input_isSmallSizePage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>
